module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('span', {
    staticClass: "logo-name"
  }, [_vm._v(_vm._s(_vm.projectName))])]), _vm._v(" "), _c('nav', {
    staticClass: "collapse navbar-collapse"
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_vm._l((_vm.menus), function(menu, index) {
    return (1 == menu.tree.wType) ? _c('li', {
      staticClass: "navbar-menu",
      class: {
        'active': index == _vm.activeIndex
      },
      on: {
        "click": function($event) {
          return _vm.menuItemClick(menu, index)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(menu.label))])]) : _vm._e()
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "navbar-empty"
  }, [_c('a', {
    staticClass: "dropdown-menu-item"
  }, [_vm._v("\n                            " + _vm._s(_vm.userName)), _c('i', {
    staticClass: "caret",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu wsui-anim-upbit wsui-anim"
  }, [_c('li', {
    on: {
      "click": _vm.profileFunDialog
    }
  }, [_vm._m(1)])])])]), _vm._v(" "), _c('li', {
    staticClass: "navbar-empty"
  }, [_c('a', [_c('el-tooltip', {
    staticClass: "item tip-logout",
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "effect": "dark",
      "content": "退出",
      "placement": "bottom"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out pointer-item",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.logout
    }
  })])], 1)])], 2)])]), _vm._v(" "), _c('wtags')], 1), _vm._v(" "), _c('ws-modal', {
    attrs: {
      "title": "个人设置",
      "width": "720px",
      "close-footer": "",
      "showClose": true
    },
    model: {
      value: (_vm.profileVisiable),
      callback: function($$v) {
        _vm.profileVisiable = $$v
      },
      expression: "profileVisiable"
    }
  }, [_c('ws-profile')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "navbar-empty navbar-empty-li"
  }, [_c('a')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("账户设置")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-4f1934b7!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/pages/framework/header.vue
// module id = 1109
// module chunks = 99